import styled from 'styled-components';
import LogoImage from '../../images/quiz/clayton-logo-3x.png';

const LogoStyles = styled.div`
    .logoCon{
        position: absolute;
        top: 12px;
        left: 50%;
        transform: translateX(-50%);
        width: 148px;
        height: 60px;
        z-index: 4;
    }

    .logo {
        background: url('${LogoImage}') no-repeat center center;
        background-size: 100%;
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-indent: -1000em;
        margin: 0;
        z-index: 4;
    }
`;

export default LogoStyles;